import { SET_RING_ID } from "./actionTypes";

const RingSelectActions = {
  setRing(competitionId, ring, ringSelectId) {
    return { type: SET_RING_ID, competitionId, ring, ringSelectId };
  },
};

export { RingSelectActions };
